import * as React from "react";
// import { createDevTools } from "redux-devtools";
// import LogMonitor from "redux-devtools-log-monitor";
// import DockMonitor from "redux-devtools-dock-monitor";

// const ReduxDevTools = createDevTools(
//   // <DockMonitor
//   //   toggleVisibilityKey="ctrl-h"
//   //   changePositionKey="ctrl-q"
//   //   defaultIsVisible={false}
//   // >
//   //   <LogMonitor theme="tomorrow" />
//   // </DockMonitor>
//   <></>
// );

const ReduxDevTools = () => {
  return <></>
}

export default ReduxDevTools;
